export const pages = require.context('@/pages', true, /index\.js$/);
export const vuePages = require.context('@/pages', true, /index\.vue$/);
export const vuexPages = require.context('@/pages', true, /store\.js$/);

export const getPage = path => {
  const p = pages(path) || {};
  return Object.assign({
    state: {},
    route: {},
    mutations: {},
    actions: {},
    getters: {}
  }, p);
};

export const getCtx = () => {
  return [...pages.keys().sort((p, n) => p.split(/[\\/]/).length - n.split(/[\\/]/).length)];
};

export const getComponent = path => {
  const c = vuePages(path.replace(/\.js$/, '.vue'));
  const component = c ? c.default : {name: `c_${Date.now()}`};
  component.name = path.replace(/\.js$/, '').replace(/\./, 'd-').replace(/[\\/]/g, '_');
  return component;
};



// WEBPACK FOOTER //
// ./src/pages.js